module.exports = __webpack_public_path__ + "img/log_editor_header.257622ef.png";